import { z } from 'zod'

export const mediaContextSearchSchema = z.object({}).passthrough()

export const galleryDetailSearchSchema = z
  .object({
    mimeType: z.string().optional()
  })
  .passthrough()
